$(document).ready(function() {
  var $productGrid = document.querySelector('#ProductGridContainer') || null;

  window.initPartnerSlider = function() {
    $('.partner_slider_new').each(function(key, val) {
      var id1 = "";
      var sliderId_1 = "";
      var id1 =  $(this).attr('id');
      var sliderId_1 = '#' + id1;
      if ( $(sliderId_1).hasClass('slick-initialized') ) {
      } else {
        $(sliderId_1).slick({
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: false,
          prevArrow: $("#l_"+id1),
          nextArrow: $("#r_"+id1),
          variableWidth: true,
          speed: 1000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                speed: 1000,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                speed: 1000,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 500,
              }
            },
            {
              breakpoint: 480,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 500,
              }
            }
          ]
        });

        // Remove aria-describedby from slick slides
        setTimeout(() => {
          const slickSlides = $(sliderId_1).find('.slick-list .slick-slide');
          adaFormatSlickSlides(slickSlides);
        }, 250);
      }

      $("#l_"+id1).hide();
      customSlickSlider();
      $(sliderId_1).on('afterChange', function (event, slick, currentSlide) {
        const $partnerSlider = slick.$slider[0];
        setSlideVisibility($partnerSlider);
        if (currentSlide === 0) {
          $("#l_"+id1).hide();
        }
        else {
          $("#l_"+id1).show();
        }
      });
    });
  }
  window.initPartnerSlider();

  /* Starts Product Slider - Karthikeyan */
  //  setInterval(function() {
  window.initProductSlider = function() {
    $('.product-list-contain').each(function(key, val) {
      var id = $(this).attr('id');
      var sliderId = '#' + id;
      $(sliderId).not('.slick-initialized').slick({
        variableWidth: true,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(this).parent().find('.prev'),
        nextArrow: $(this).parent().find('.next'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            }
          }
        ]
      });
      customSlickSlider();
      $('.product-list-contain').on('afterChange', function (event, slick) {
        const $productListSlider = slick.$slider[0];
        setSlideVisibility($productListSlider);
      });

      // Remove aria-describedby from slick slides
      setTimeout(() => {
        const slickSlides = $(sliderId).find('.slick-list .slick-slide');
        adaFormatSlickSlides(slickSlides);
      }, 250);
      //}, 500);
    })
  }
  window.initProductSlider();
  /* Ends Product Slider - Karthikeyan */

    $(document).on('click', '.freq-select-products', function() {
        if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
            var productList = "ATTACH :: Cart Page";
        } else {
            var mpn_handle = $("#mpn_handle").val();
            var productList = "Shopify Rec :: " + mpn_handle;
        }
        localStorage.setItem("product-click", productList);
    });

    $(document).on('change', '.frequent-products-checkbox', function() {
        var checkLength = $("input[name='frequent-products-pdp']:checked").length;
        $("#checked-products").text(checkLength);
        if (checkLength == 0) {
            $('#card-button').prop("disabled", true);
        } else {
            $('#card-button').prop("disabled", false);
        }
        var product_id = $(this).val();
        var prodtitle = $("#title_" + product_id).val();
        var prodMPN = $("#product_mpn_handle_" + product_id).val();
        var prodType = $(".card_product_category_" + product_id).val();
        var prodCurrency = $(".card_product_currency_" + product_id).attr("value");
        var prodPrice = $(".card_product_price_" + product_id).attr("value");
        var compareprice = $(".card_product_compare_" + product_id).attr("value");
        var prodSku = $(".card_product_sku_" + product_id).attr("value");
        prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
        prodPrice = parseFloat(prodPrice);
        var prodSku = $(".card_product_sku_" + product_id).attr("value");
        if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
            var productList = "ATTACH :: Cart Page";
        } else {
            var mpn_handle = $("#mpn_handle").val();
            var productList = "Shopify Rec :: " + mpn_handle;
        }
        localStorage.setItem("product-click", productList);
        dataLayer.push({
            'ecommerce': null
        });
        dataLayer.push({
            'event': 'select_item',
            'ecommerce': {
                'item_list_name': productList,
                'items': [{
                    'item_id': prodSku,
                    'item_name': prodtitle,
                    'item_category': prodType,
                    'price': prodPrice,
                    'quantity': 1,
                }]
            }
        });
    });


    $(document).on('click', '#card-button', function(event) {
        event.preventDefault();
        var $CTOcartDrawer = $('cto-cart-drawer');
        $('.button-cart-frequent').attr('aria-disabled', true);
        $('.button-cart-frequent').addClass('loading');
        $('.loading-overlay__spinner-frequent').removeClass('hidden');
        var frequentProducts = [];
        var frequentProducts_ga = [];
        var tax_total_quantity = 0;
        var quncheck = [];
        var prodTitle = [];
        var value_price = 0;
        var prodCurrency = $("#prod_currency").val();
        $.each($("input[name='frequent-products-pdp']:checked"), function() {
            /* Order Product Limits - Karthikeyan */
            var prodId = $("#product_id_" + $(this).val()).val();
            var prodQuant = 1;
            var prodMaxqut = $("#product_max_quantity_" + $(this).val()).val();
            var prodtitle = $("#title_" + $(this).val()).val();
            var prodMPN = $("#product_mpn_handle_" + $(this).val()).val();
            var prod_handle = $("#card_product_handle_" + $(this).val()).val();
            var prodPreorder = $("#card_product_preorder_" + $(this).val()).val();
            var prodPreorderMessage = $("#card_product_preorder_message_" + $(this).val()).val();
            var prodBackorder = $("#card_product_backorder_" + $(this).val()).val();
            var prodTradeIn = $("#card_product_tradein_" + $(this).val()).val();
            if (prodMaxqut != "") {
                var maxQuant = checkMaxquantity(prodId);
                if (maxQuant != "") {
                    var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
                } else {
                    var max_total_quantity = parseInt(prodQuant);
                }

                if (max_total_quantity > prodMaxqut) {
                    quncheck.push(1);
                    prodTitle.push(prodtitle);
                }
            }
            var taxtags_fb = $("#tags_" + $(this).val()).val();
            var addtaxfree = taxtags_fb.indexOf('taxfree') != -1;
            if (addtaxfree == true) {
                tax_total_quantity++
            }
            var isCTOSku = !!$CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden') && this === $("input[name='frequent-products-pdp']").get(0);
            item = {}
            item["quantity"] = 'quantity:1';
            item["id"] = $(this).val();
            item["properties"] = {
                _uuid: prod_handle,
                ...((prodPreorder === 'true' || prodBackorder === 'true') && { _preOrder: 'true' }),
                ...(prodPreorderMessage && prodBackorder !== 'true' && { _preOrderMessage: prodPreorderMessage }),
                ...(prodBackorder === 'true' && { _backOrder: 'true' }),
                ...(prodPreorder !== 'true' && prodBackorder !== 'true' && { _inStock: 'true' }),
                ...(prodTradeIn === 'true' && { _tradeInEligible: 'true' }),
                ...(isCTOSku && { _cto_product: 'true' }),
            }
            frequentProducts.push(item);
            var prodType = $(".card_product_category_" + $(this).val()).val();

            var prodPrice = $(".card_product_price_" + $(this).val()).attr("value");
            var prodSku = $(".card_product_sku_" + $(this).val()).attr("value");
            var compareprice = $(".card_product_compare_" + $(this).val()).attr("value");
            var productList = $(".button-cart-frequent").attr("product-list");
            var mpn_handle = $("#mpn_handle").val();
            var shopify_rec = "Shopify Rec :: " + mpn_handle;
            prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
            value_price += parseFloat(prodPrice);
            value_price = parseFloat(value_price);
            var productPrice1 = parseFloat(prodPrice);
            item_ga = {}
            item_ga["item_id"] = prodSku;
            item_ga["item_name"] = prodtitle;
            item_ga["item_category"] = prodType;
            item_ga["item_list_name"] = shopify_rec;
            item_ga["price"] = parseFloat(productPrice1);
            item_ga["quantity"] = 1;
            frequentProducts_ga.push(item_ga);


        });

        if (jQuery.inArray(1, quncheck) !== -1) {
            var prod_title = prodTitle.join();
            alert(quantity_limit_error_message + " " + prod_title);
            $('.button-cart-frequent').attr('aria-disabled', false);
            $('.button-cart-frequent').removeClass('loading');
            $('.loading-overlay__spinner-frequent').addClass('hidden');
            return false;
        }
        /* VAT Product Limits - Karthikeyan */
        if (vat_free_day == true) {
            if (getCookie('total_quantity') == "") {
                var tax_total_quantity = parseInt(tax_total_quantity);
            } else {
                var tax_total_quantity = parseInt(tax_total_quantity) + parseInt(getCookie('total_quantity'));
            }
            if (tax_total_quantity > vat_free_quantity) {
                alert(vat_free_message);
                $('.button-cart-frequent').attr('aria-disabled', false);
                $('.button-cart-frequent').removeClass('loading');
                $('.loading-overlay__spinner-frequent').addClass('hidden');
                return false;
            }
        }

        const adobeItems = frequentProducts.map(item => {
          return {
            ...item,
            quantity: item.quantity?.replace('quantity:', '') || 1,
          }
        });

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    items: frequentProducts
                }),
            }).then(response => {
                 response.json().then(d => {
                   var mpn_handle = $("#mpn_handle").val();
                   var shopify_rec = "Shopify Rec :: " + mpn_handle;
                    var exphone_fa = [];
                   if (JSON.parse(localStorage.getItem("cart")) != null) {
                            exphone_fa = JSON.parse(localStorage.getItem("cart"));
                    }
                    for (var i = 0; i < d.items.length; i++) {
                        item_cart_fa = {}
                        item_cart_fa["cart_item_id"] = d.items[i].key;
                        item_cart_fa["cart_item_list_name"] = shopify_rec;
                        item_cart_fa["cart_item_mpn"] = d.items[i].sku;
                        exphone_fa.push(item_cart_fa);
                    }
                   // console.log("1");
                   // console.log(exphone_fa);
                   localStorage.setItem("cart", JSON.stringify(exphone_fa));

                  if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
                    $CTOcartDrawer[0].forceClearCtoItems();
                    $CTOcartDrawer[0].updateItems(d.items);
                  }

                  adobeTrackAddToCart({
                    items: adobeItems,
                    context: 'Frequently Bought Together',
                    $trigger: $('#card-button')[0],
                  });
                })

                // checkQuantity();
                $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
                    var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
                    if ($('.cart-count-bubble').length > 0) {
                        $('.cart-count-bubble span').text(item_count);
                    } else {
                        $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                        $('.cart-count-bubble span').text(item_count);
                    }
                    $("#cart-notification").text("");
                    var textreplace = "<div id='min-cart-replace'></div>";
                    $("#cart-notification").append(textreplace);
                    $("#cart-notification").replaceWith(itemData);
                    if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                      $('#cart-notification').addClass('minicart-active');
                    }
                });
                dataLayer.push({
                    'ecommerce': null
                });
                dataLayer.push({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'value': value_price,
                        'currency': prodCurrency,
                        'items': frequentProducts_ga
                    }
                });

                $('.button-cart-frequent').attr('aria-disabled', false);
                $('.button-cart-frequent').removeClass('loading');
                $('.loading-overlay__spinner-frequent').addClass('hidden');
                if (window.location.href.indexOf("/cart") > -1) {
                    window.onCartUpdate();
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                return false;
            });
        return false;
    });
    /* Ends Frequently add Products Karthikeyan */

    function quickAddEvents() {
      $(".slider-form").click(function(evt) {
        evt.preventDefault();
        var $CTOcartDrawer = $('cto-cart-drawer');
        var mpn_handle = $("#mpn_handle").val();
        /* Order Product Limits - Karthikeyan */
        var pageName = window.location.href;
        var prodId = $(this).attr("data-productid");
        var prodQuant = 1;
        var prodMaxqut = $(this).attr("data-productmaxquantity");
        var cartpage = $(this).attr("data-cartpage");
        if (cartpage == "Cart Page") {
            var attach = "ATTACH :: Cart Page";
        } else {
            var attach = "ATTACH :: ";
        }
        if (prodMaxqut != "") {
            var maxQuant = checkMaxquantity(prodId);
            if (maxQuant != "") {
                var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
            } else {
                var max_total_quantity = parseInt(prodQuant);
            }
            if (max_total_quantity > prodMaxqut) {
                alert(quantity_limit_error_message);
                return false;
            }
        }
        var slider_variantid = $(this).attr("data-variantid");
        var slider_tag = $(this).attr("data-tag");
        //souvik code for product list tracking starts
        var collection_name = $(this).attr("data-collection");
        var main_product_sku = $(this).attr("data-productsku");
        if (pageName.includes("products")) {
            var mpn_handle = $("#mpn_handle").val();
            var productList = mpn_handle;
        } else if (pageName.includes("search")) {
          var productList = 'Search Results';
        } else {
          var productList = formatString($(this).attr("data-productlist"));
        }
        var productCategory = $(this).attr("data-producttype");
        var productPrice = $(this).attr("data-productprice");
        var productcomPrice = $(this).attr("data-productcompprice");
        var productCurrency = $(this).attr("data-productcurrency");
        var productTitle = $(this).attr("data-producttitle");
        var productMPN = $(this).attr("data-productMPN");
        var productHandle = $(this).attr("data-producthandle");
        var productPreOrder = $(this).attr("data-productpreorder");
        var productPreOrderMessage = $(this).attr("data-productpreordermessage");
        var productBackOrder = $(this).attr("data-productbackorder");
        var productTradeIn = $(this).attr("data-producttradein");
        var gwpData = $(this).find('.js-slider-form-gwp-data');
        var hasGwp = gwpData.length > 0;
        //souvik code for product list trackingends

        /* VAT Product Limits - Karthikeyan */
        if (vat_free_day == true) {
            var addtaxfree = slider_tag.indexOf('taxfree') != -1;
            if (addtaxfree == true) {
                if (getCookie('total_quantity') >= vat_free_quantity) {
                    alert(vat_free_message);
                    return false;
                }
            }
        }
        $('#slider-form-' + slider_variantid).attr('aria-disabled', true);
        $('#slider-form-' + slider_variantid).addClass('loading');
        $('.loading-overlay__spinner-frequent').removeClass('hidden');

        var uid = productHandle;

        if (hasGwp) {
          gwpData.each(function() {
            uid = uid + '-' + $(this).data('gwp-product-handle');
          });
        }

        const props = {
          _uuid: uid,
          ...((productPreOrder === 'true' || productBackOrder === 'true') && { _preOrder: 'true' }),
          ...(productPreOrderMessage && productBackOrder !== 'true' && { _preOrderMessage: productPreOrderMessage }),
          ...(productBackOrder === 'true' && { _backOrder: 'true' }),
          ...(productPreOrder !== 'true' && productBackOrder !== 'true' && { _inStock: 'true' }),
          ...(productTradeIn === 'true' && { _tradeInEligible: 'true' }),
        };

        if (hasGwp) {
          var gwpSkus = [];
          var gwpHandles = [];
          gwpData.each(function() {
            gwpSkus.push($(this).data('gwp-product-sku'));
            gwpHandles.push($(this).data('gwp-product-handle'));
          });
          props._gwp_sku = gwpSkus.join(',');
          props._gwp_handle = gwpHandles.join('-');
        }

        var items = [{
          id: slider_variantid,
          quantity: 1,
          properties: props,
        }];

        if (hasGwp) {
          gwpData.each(function() {
            items.push({
              id: $(this).data('gwp-id'),
              quantity: $(this).data('gwp-quantity'),
              properties: {
                _gwp_main_product_sku: main_product_sku,
                _gwp_main_product_handle: productHandle,
                _uuid: uid
              }
            });
          });
        }

        const adobeItems = [];
        items.forEach(item => {
          adobeItems.push({
            id: item.id,
            quantity: item.quantity,
          });
        });

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({items}),
            }).then(response => {

                response.json().then(d => {
                  cartCookie(productMPN, d.items[0].key, prod_list);

                  if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
                    $CTOcartDrawer[0].updateItems(d.items);
                  }
                })

                //checkQuantity();
                if (cartpage == "Cart Page") {
                  var prod_list = attach;
                } else if (pageName.includes("search"))  {
                  var prod_list = productList;
                } else  {
                  var prod_list = attach + productList;
                }

                removeGwpData(gwpData);

                //souvik code for product list tracking starts
                triggerGAAddToCart(productcomPrice, main_product_sku, productTitle, productCategory, prod_list, productCurrency, productPrice, prodQuant, main_product_sku, slider_variantid);
                //souvik code for product list tracking ends

                adobeTrackAddToCart({
                  items: adobeItems,
                  context: 'Quick Add',
                  $trigger: this,
                });

                if (cartpage == "Cart Page") {
                    window.onCartUpdate({ scrollToTop: true });
                    return false;
                }
                $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
                    var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
                    if ($('.cart-count-bubble').length > 0) {
                        $('.cart-count-bubble span').text(item_count);
                    } else {
                        $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                        $('.cart-count-bubble span').text(item_count);
                    }
                    $("#cart-notification").text("");
                    var textreplace = "<div id='min-cart-replace'></div>";
                    $("#cart-notification").append(textreplace);
                    $("#cart-notification").replaceWith(itemData);
                    if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                      $('#cart-notification').addClass('minicart-active');
                    }
                });
                $('#slider-form-' + slider_variantid).attr('aria-disabled', false);
                $('#slider-form-' + slider_variantid).removeClass('loading');
                $('.loading-overlay__spinner-frequent').addClass('hidden');
            })
            .catch((error) => {
                console.error('Error:', error);
                return false;
            });
        return false;
      });
    }

    quickAddEvents();
    window.quickAddEvents = quickAddEvents;

    /*Add Applecare on cart page functionality  starts here - added by Hema*/
    $(document).on('click', '.add-cart-apple-care', async function(e) {
        e.preventDefault();
        var $CTOcartDrawer = $('cto-cart-drawer');
        $(this).prop('disabled', true);

        if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
        var add_button = $(this);
        var product_id = add_button.data('variantid');
        var main_product_index = add_button.data('forproduct');
        var wp_idx = add_button.data('forwproduct');
        var wp_key = add_button.data('forwkey');
        var wp_idx2 = add_button.data('forwproduct2');
        var wp_key2 = add_button.data('forwkey2');
        var wp_idx_gwp = add_button.data('forwproductgwp');
        var wp_key_gwp = add_button.data('forwkeygwp');
        var previous_uid = add_button.data('uuid');
        var main_product_parent = $('#CartItem-' + main_product_index);
        var has_applcr_sku = main_product_parent.data('applecare_sku')?.trim();
        var has_applcr_handle = main_product_parent.data('applecare_handle');
        var has_sw_sku = main_product_parent.data('secwarranty_sku')?.trim();
        var has_sw_handle = main_product_parent.data('secwarranty_handle');
        var has_gwp_sku = main_product_parent.data('gwp_sku')?.trim();
        var has_gwp_handle = main_product_parent.data('gwp_handle');
        var isCTO = main_product_parent.data('cto-product');
        var main_product_quantity = main_product_parent.find('.quantity__input')?.val();
        var main_product_sku = add_button.data('skuparent');
        var main_product_handle = add_button.data('handleparent');
        var main_product_preorder = add_button.data('preorderparent');
        var main_product_preorder_message = add_button.data('preordermessageparent');
        var main_product_backorder = add_button.data('backorderparent');
        var main_product_trade_in = add_button.data('tradeinparent');
        var main_product_key = add_button.data('keyparent');
        var aplCr_sku = add_button.data('skuaplcr');
        var applecarempn = add_button.data('mpnaplcr');
        var aplCr_handle = add_button.data('handleaplcr');
        var main_mpn_value = add_button.data('mpnparent');
        var additional_flag = add_button.data('reference')
        var main_product_tags = main_product_parent.find('.cart_tax_tags')?.val();
        var override_quantity = add_button.data('overridequantity');
        const tradeInValue = $(main_product_parent).data('tradeInValue');
        const tradeInDevice = $(main_product_parent).data('tradeInDevice');

        let add_gwp_skus = [];
        let add_gwp_handles = [];
        $(`.add-cart-apple-care[data-reference="gwp"][data-skuaplcr="${aplCr_sku}"][data-handleaplcr="${aplCr_handle}"], .gwp_dpnd_${main_product_index}`).each(function() {
          let gwp_sku;
          let gwp_handle;
          if ($(this).hasClass('add-cart-apple-care')) {
            gwp_sku = $(this).data('skuaplcr');
            gwp_handle = $(this).data('handleaplcr');
          } else {
            gwp_sku = $(this).find('cart-remove-button').data('gwp-sku');
            gwp_handle = $(this).find('cart-remove-button').data('gwp-handle');
          }

          if (!add_gwp_handles.includes(gwp_handle)) {
            add_gwp_skus.push(gwp_sku);
            add_gwp_handles.push(gwp_handle);
          }
        });

        var data = {
          line: main_product_index,
          quantity: main_product_quantity,
          properties: {},
        };

        if (main_product_preorder) {
          data.properties._preOrder = 'true';
        }

        if (main_product_preorder_message && !main_product_backorder) {
          data.properties._preOrderMessage = main_product_preorder_message;
        }

        if (main_product_backorder) {
          data.properties._backOrder = 'true';
        }

        if (!main_product_preorder && !main_product_backorder) {
          data.properties._inStock = 'true';
        }

        if (main_product_trade_in) {
          data.properties._tradeInEligible = 'true';
        }

        if (isCTO) {
          data.properties._cto_product = 'true';
        }

        if (tradeInValue) {
          data.properties._tradeIn_value = tradeInValue.toString().replace('.', '');
        }

        if (tradeInDevice) {
          data.properties._tradeIn_device = tradeInDevice;
        }

        var uid = main_product_handle;

        if (additional_flag == "aplcr") {
          uid = uid + '-' + aplCr_handle;
          data.properties._applecare_sku = aplCr_sku;
          data.properties._applecare_handle = aplCr_handle;
        } else if (has_applcr_sku) {
          uid = uid + '-' + has_applcr_handle;
          data.properties._applecare_sku = has_applcr_sku;
          data.properties._applecare_handle = has_applcr_handle;
        }

        if (additional_flag == "secwr") {
          uid = uid + '-' + aplCr_handle;
          data.properties._secWarranty_sku = aplCr_sku;
          data.properties._secWarranty_handle = aplCr_handle;
        } else if (has_sw_sku) {
          uid = uid + '-' + has_sw_handle;
          data.properties._secWarranty_sku = has_sw_sku;
          data.properties._secWarranty_handle = has_sw_handle;
        }

        if (additional_flag == "gwp") {
          uid = uid + '-' + add_gwp_handles.join('-');
          data.properties._gwp_sku = add_gwp_skus.join(',');
          data.properties._gwp_handle = add_gwp_handles.join('-');
        } else if (has_gwp_sku) {
          uid = uid + '-' + has_gwp_handle;
          data.properties._gwp_sku = has_gwp_sku;
          data.properties._gwp_handle = has_gwp_handle;
        }

        data.properties._uuid = uid;

        data = JSON.stringify(data);

        if (!has_applcr_sku && !has_sw_sku && !has_gwp_sku) {
          var wp_idx = 0;
          var wp_idx2 = 0;
        }

        var data = await $.ajax({
          url: `${window.Shopify.routes.root}cart/change.js`,
          type: "POST",
          data: data,
          contentType: "application/json",
          dataType: 'json',
        });

        if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
          var newCTOItem = data.items?.find((item) => item.properties?._cto_product);
          var newCTOItemKey = newCTOItem?.key;
          var newCTOItemUuid = newCTOItem?.properties?._uuid;
          $CTOcartDrawer[0].updateCtoItemKey(newCTOItemKey);
        }

        var checked = {};
        if (wp_key) {
          if (has_applcr_sku && !checked[has_applcr_sku]) {
            var newWpKey = data.items.find(item => item.properties?._aplcr_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid)?.key || wp_key;
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _aplcr_main_product_sku: main_product_sku,
                _aplcr_main_product_handle: main_product_handle,
                _uuid: uid,
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_applcr_sku] = true;
          } else if (has_sw_sku && !checked[has_sw_sku]) {
            var newWpKey = data.items.find(item => item.properties?._sw_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid)?.key || wp_key;
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _sw_main_product_sku: main_product_sku,
                _sw_main_product_handle: main_product_handle,
                _uuid: uid,
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_sw_sku] = true;
          }

          var data = await $.ajax({
            url: `${window.Shopify.routes.root}cart/change.js`,
            type: "POST",
            data: data2,
            contentType: "application/json",
            dataType: 'json',
          });
        }

        if (wp_key2) {
          if (has_applcr_sku && !checked[has_applcr_sku]) {
            var newWpKey = data.items.find(item => item.properties?._aplcr_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid)?.key || wp_key2;
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _aplcr_main_product_sku: main_product_sku,
                _aplcr_main_product_handle: main_product_handle,
                _uuid: uid,
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_applcr_sku] = true;
          } else if (has_sw_sku && !checked[has_sw_sku]) {
            var newWpKey = data.items.find(item => item.properties?._sw_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid)?.key || wp_key2;
            var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
            var data2 = {
              line: newWpLine,
              quantity: main_product_quantity,
              properties: {
                _sw_main_product_sku: main_product_sku,
                _sw_main_product_handle: main_product_handle,
                _uuid: uid,
              },
            };
            data2 = JSON.stringify(data2);
            checked[has_sw_sku] = true;
          }

          var data = await $.ajax({
            url: `${window.Shopify.routes.root}cart/change.js`,
            type: "POST",
            data: data2,
            contentType: "application/json",
            dataType: 'json',
          });
        }

        if (wp_key_gwp) {
          if (has_gwp_sku && !checked[has_gwp_sku]) {
            var newWpItems = data.items.filter(item => item.properties?._gwp_main_product_sku === main_product_sku && item.properties?._uuid === previous_uid);
            checked[has_gwp_sku] = true;

            for (const newWpItem of newWpItems) {
              var newWpKey = newWpItem?.key;
              var newWpLine = data.items.findIndex(item => item.key === newWpKey) + 1;
              var newWpQuantity = newWpItem?.quantity || 1;
              var data2 = {
                line: newWpLine,
                quantity: newWpQuantity,
                properties: {
                  _gwp_main_product_sku: main_product_sku,
                  _gwp_main_product_handle: main_product_handle,
                  _uuid: uid,
                },
              };
              data2 = JSON.stringify(data2);

              var data = await $.ajax({
                url: `${window.Shopify.routes.root}cart/change.js`,
                type: "POST",
                data: data2,
                contentType: "application/json",
                dataType: 'json',
              });
            }
          }
        }

        var itemToAdd = {
          id: product_id,
          quantity: override_quantity || main_product_quantity,
          properties: {
            _uuid: uid,
          },
        };

        if (additional_flag == "secwr") {
          itemToAdd.properties._sw_main_product_sku = main_product_sku;
          itemToAdd.properties._sw_main_product_handle = main_product_handle;
        } else if (additional_flag == "aplcr") {
          itemToAdd.properties._aplcr_main_product_sku = main_product_sku;
          itemToAdd.properties._aplcr_main_product_handle = main_product_handle;
        } else if (additional_flag == "gwp") {
          itemToAdd.properties._gwp_main_product_sku = main_product_sku;
          itemToAdd.properties._gwp_main_product_handle = main_product_handle;
        }

        var resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "post",
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            items: [itemToAdd],
          }),
        });

        if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
          var d = await resp.json();
          // when a gwp adds a discount to the CTO product, the item key for the CTO product may change
          if (d.items?.some((item) => item.discounts?.length)) {
            var cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
            var newCTOItem = cartData.items.find((item) => item.properties?._cto_product && item.properties?._uuid === newCTOItemUuid);
            var newCTOItemKey = newCTOItem?.key;
            $CTOcartDrawer[0].updateCtoItemKey(newCTOItemKey);
          }
          $CTOcartDrawer[0].updateItems(d.items);
        }

        window.onCartUpdate();
    });
    /*Add Applecare on cart page functionality  ends here - added by Hema*/

    /*
    	Add Trade-In on cart page
    */
    $(document).on('click', '.add-cart-trade-in', function(e) {
      e.preventDefault();
      $(this).prop('disabled', true);

      if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
      const add_button = $(this);
      const tradeInValue = add_button.data('tradeInValue');
      const tradeInDevice = add_button.data('tradeInDevice');
      const main_product_id = add_button.data('parentId');
      const main_product_index = add_button.data('forproduct');
      const main_product_parent = $(`#${main_product_id}`);
      const main_product_quantity = main_product_parent.find('.quantity__input').val();
      const main_product_sku = add_button.data('skuparent');
      const main_product_handle = add_button.data('handleparent');
      const main_product_preorder = add_button.data('preorderparent');
      const main_product_preorder_message = add_button.data('preordermessageparent');
      const main_product_backorder = add_button.data('backorderparent');
      const main_product_trade_in = add_button.data('tradeinparent');
      const main_product_key = add_button.data('keyparent');
      const main_mpn_value = add_button.data('mpnparent');
      const additional_flag = add_button.data('reference')
      const main_product_tags = main_product_parent.find('.cart_tax_tags').val();

      let properties = $(this).data('itemProperties');

      delete properties._preOrder;
      delete properties._preOrderMessage;
      delete properties._backOrder;
      delete properties._inStock;

      if (main_product_preorder) properties._preOrder = 'true';
      if (main_product_preorder_message && !main_product_backorder) properties._preOrderMessage = main_product_preorder_message;
      if (main_product_backorder) properties._backOrder = 'true';
      if (!main_product_preorder && !main_product_backorder) properties._inStock = 'true';
      if (tradeInDevice) properties._tradeInEligible = 'true';
      if (tradeInValue) properties._tradeIn_value = tradeInValue.toString().replace('.', '');
      if (tradeInDevice) properties._tradeIn_device = tradeInDevice;

      if (tradeInDevice && properties._uuid && !properties._uuid.includes('tradein')) {
        properties._uuid = properties._uuid + '-tradein';
      }

      // *** UNCOMMENT AFTER QUANTITY SELECTOR IS ADDED *** //
      // const data_tradeIn = `{
      //   "line": ${main_product_index},
      //   "quantity": ${main_product_quantity,
      //   "properties": ${JSON.stringify(properties)}
      // }`;

      // *** TEMPORARY *** //
      // Remove after quantity selector is added
      const data_tradeIn = `{
        "line": ${main_product_index},
        "quantity": ${main_product_quantity || 1},
        "properties": ${JSON.stringify(properties)}
      }`;

      $.ajax({
        url: `${window.Shopify.routes.root}cart/change.js`,
        type: "POST",
        data: data_tradeIn,
        contentType: "application/json",
        dataType: 'json',
        success: function(data) {
          const oldUuid = properties?._uuid.split('-tradein')[0];
          const newUuid = properties?._uuid;

          if (!oldUuid || !newUuid || oldUuid === newUuid) return;

          const appleCareProductsThatNeedUpdating = data.items.find(item => item.properties?._aplcr_main_product_sku && item.properties?._uuid === oldUuid);
          const secWarrantyProductsThatNeedUpdating = data.items.find(item => item.properties?._sw_main_product_sku && item.properties?._uuid === oldUuid);
          const gwpProductsThatNeedUpdatingArr = data.items.filter(item => item.properties?._gwp_main_product_sku && item.properties?._uuid === oldUuid);

          async function updateAcSecProducts() {
            if (appleCareProductsThatNeedUpdating) {
              const newProperties = { ...appleCareProductsThatNeedUpdating.properties, _uuid: newUuid };
              const line = data.items.findIndex(item => item.key === appleCareProductsThatNeedUpdating.key) + 1;
              const newData = {
                line,
                quantity: appleCareProductsThatNeedUpdating.quantity,
                properties: newProperties,
              };
              await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: {
                  'content-type': 'application/json'
                },
                body: JSON.stringify(newData),
              });
            }

            if (secWarrantyProductsThatNeedUpdating) {
              const newProperties = { ...secWarrantyProductsThatNeedUpdating.properties, _uuid: newUuid };
              const line = data.items.findIndex(item => item.key === secWarrantyProductsThatNeedUpdating.key) + 1;
              const newData = {
                line,
                quantity: secWarrantyProductsThatNeedUpdating.quantity,
                properties: newProperties,
              };
              await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: {
                  'content-type': 'application/json'
                },
                body: JSON.stringify(newData),
              });
            }

            if (gwpProductsThatNeedUpdatingArr.length) {
              for (const gwpProductsThatNeedUpdating of gwpProductsThatNeedUpdatingArr) {
                const newProperties = { ...gwpProductsThatNeedUpdating.properties, _uuid: newUuid };
                const line = data.items.findIndex(item => item.key === gwpProductsThatNeedUpdating.key) + 1;
                const newData = {
                  line,
                  quantity: gwpProductsThatNeedUpdating.quantity,
                  properties: newProperties,
                };
                await fetch(`${window.Shopify.routes.root}cart/change.js`, {
                  method: "POST",
                  headers: {
                    'content-type': 'application/json'
                  },
                  body: JSON.stringify(newData),
                });
              }
            }

            location.reload();
          }

          updateAcSecProducts();
        },
        error: function(xhr, status, error) {
          console.log(`Error: ${xhr.responseText}`);
        }
      });
    });

    /* sticky atc on pdp functionality  starts here - added by Hema*/
    $(document).on('click', '#footer-atc', function(evt) {
        evt.preventDefault();
        /* Order Product Limits - Karthikeyan */
        var prodVariantID = $("#main-product-variant").val();
        var prodQuant = $("#prodQuantity").val();
        var total_qty = $("#total_qty_" + prodVariantID).val();
        /* VAT Product Limits - Karthikeyan */
        const isValidQty = checkQty();

        if (!isValidQty) {
            return false;
        }
        // Additional logic to check trade-in field
        const tradeInEntry = document.querySelector('.trade-in-container');
        const tradeinChoice = document.querySelector('input[name="tradein"]:checked')?.value;
        if(!!tradeInEntry && !tradeinChoice){
            const tradeInInputError = document.querySelector('.trade-in-error');
            tradeInInputError.classList.add('active');
            tradeInEntry.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }
        if (vat_free_day == true) {
            var taxtags = $("#tax_tags").val();
            var prodQuant = $("#prodQuantity").val();
            var addtaxfree = taxtags.indexOf('taxfree') != -1;
            if (getCookie('total_quantity') == "") {
                var tax_total_quantity = parseInt(prodQuant);
            } else {
                var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie('total_quantity'));
            }

            if (addtaxfree == true) {
                if (tax_total_quantity > vat_free_quantity) {
                    alert(vat_free_message);
                    return false;
                } else {
                    addToCart("cart");
                }
            } else {
                addToCart("cart");
            }
        } else {
            addToCart("cart");
        }
        return false;
    });


    $(document).on('click', '.js-checkout-button,.js-checkout-link', function(evt) {
      evt.preventDefault();
      //   var tttype = $(".shopify-payment-button__button").attr("type");
      var prodVariantID = $("#main-product-variant").val();
      var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
      const isValidQty = checkQty();

      if (!isValidQty) {
        return false;
      }
      if (vat_free_day == true) {
        var taxtags = $("#tax_tags").val();
        var prodQuant = $("#prodQuantity").val();
        var addtaxfree = taxtags.indexOf('taxfree') != -1;

        if (getCookie('total_quantity') == "") {
          var tax_total_quantity = parseInt(prodQuant);
        } else {
          var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie('total_quantity'));
        }

        if (addtaxfree == true) {
          if (tax_total_quantity > vat_free_quantity) {
            alert(vat_free_message);
            return false;
          }
        }
      }
      if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
        var proliststring = $(".pdp_product_list").attr("value");
      } else {
        var proliststring = formatString($(".pdp_product_list").attr("value"));
      }
      var productList = proliststring;
      // cartCookie(mpn_handle, prodVariantID, productList);

      $('.js-checkout-button,.js-checkout-link').attr('disabled', true);
      addToCart("buy");
    });

    /* sticky atc on pdp functionality  ends here - added by Hema*/




    function addToCart(check_buy) {
      var $cartDrawer = document.querySelector('cart-drawer') || null;
      var $CTOcartDrawer = $('cto-cart-drawer');
      var isCTO = event?.target?.dataset.ctoProduct === 'true'
        || event?.target?.closest('.js-checkout-button,.js-checkout-link')?.dataset.ctoProduct === 'true'
        || false;
      var taxtags = $("#tax_tags").val();
      var btn = $(this).find(".BUY_NOW_CLICKED");
      var buy_now_checker = btn.data('submit');
      /* Applecare PDP  starts here - added by Hema*/
      var isChecked = $('#add-apple-care').is(':checked');
      var isChecked2 = $('#add-secWarranty').is(':checked');
      var hasGwp = $('.js-gwp-data').length > 0;
      var hasTradeIn = $('#selected-trade-in-value').val() !== undefined && $('#selected-trade-in-value').val() !== '0' && $("#selected-trade-in-device").val() !== '';
      const tradeInValue = $("#selected-trade-in-value").val() || ''; // Get Trade-In value
      const parsedTradeInValue = hasTradeIn ? parseInt(tradeInValue).toFixed(2).replace('.', '') : null; // Set parsed Trade-In value
      const tradeInDevice = $("#selected-trade-in-device").val() || ''; // Get Trade-In value
      var prodVariantID = $('#main-product-variant').val();
      var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
      var productcomPrice = $("#compr_price_" + prodVariantID).val();
      var uuid = Math.random().toString(36).slice(2);

      const disablePdpButton = (disable) => {
        if (check_buy === 'cart') {
          $('#footer-atc').attr('disabled', disable);
        }
      }

      const adobeTrack = (items) => {
        adobeTrackAddToCart({
          items,
          context: check_buy === 'cart' ? 'PDP Add to Cart' : 'Check out with Apple Pay',
          $trigger: check_buy === 'cart' ? $('#footer-atc')[0] : null,
          triggerText: check_buy !== 'cart' ? 'Check out with Apple Pay' : null,
          triggerUrl: check_buy !== 'cart' ? `${window.location.origin}${window.Shopify.routes.root}checkout` : null,
        });
      }

      disablePdpButton(true);

      var applecareID = $("#apple-care-varid").val(); //Getting apple care id
      var applecaresku = $("#applecare-product-sku").val(); //Getting apple care sku
      var applecarehandle = $("#applecare-product-handle").val(); //Getting apple care handle
      var secWarrantyID = $("#secWarranty-varid").val(); //Getting secWarranty id
      var secWarrantysku = $("#secWarranty-product-sku").val(); //Getting secWarranty sku
      var secWarrantyhandle = $("#secWarranty-product-handle").val(); //Getting secWarranty handle
      var gwpData = $('.js-gwp-data'); //Getting gwp data
      var main_product_sku = $("#main-pro-sku").val(); //Getting MAIN PRODUCT SKU
      var main_product_handle = $("#main-pro-handle").val(); //Getting main product handle
      var main_product_preorder = $("#main-pro-preorder").val(); //Getting main product preorder value
      var main_product_preorder_message = $("#main-pro-preorder-message").val(); //Getting main product preorder message value
      var main_product_backorder = $("#main-pro-backorder").val(); //Getting main product backorder value
      var main_product_trade_in = $("#main-pro-trade-in").val(); //Getting main product trade-in value
      var prodVariantID = $('#main-product-variant').val(); //Getting main product id
      var prodQuant = $("#prodQuantity").val(); //Getting main product QUANTITY
      var uid = main_product_handle;

      if (isChecked == true) {
        uid = uid + '-' + applecarehandle;
      }
      if (isChecked2 == true) {
        uid = uid + '-' + secWarrantyhandle;
      }
      if (hasGwp) {
        gwpData.each(function() {
          uid = uid + '-' + $(this).data('gwp-product-handle');
        });
      }
      if (tradeInDevice && !uid.includes('tradein')) {
        uid = uid + '-tradein';
      }

      const props = {
        _uuid: uid,
        ...(main_product_preorder === 'true' && { _preOrder: 'true' }),
        ...(main_product_preorder_message && main_product_backorder !== 'true' && { _preOrderMessage: main_product_preorder_message }),
        ...(main_product_backorder === 'true' && { _backOrder: 'true' }),
        ...(main_product_preorder !== 'true' && main_product_backorder !== 'true' && { _inStock: 'true' }),
        ...(main_product_trade_in === 'true' && { _tradeInEligible: 'true' }),
      };

      if (isChecked == true) {
        props._applecare_sku = applecaresku;
        props._applecare_handle = applecarehandle;
      }

      if (isChecked2 == true) {
        props._secWarranty_sku = secWarrantysku;
        props._secWarranty_handle = secWarrantyhandle;
      }

      if (isCTO) {
        props._cto_product = 'true';
      }

      if (hasGwp) {
        var gwpSkus = [];
        var gwpHandles = [];
        gwpData.each(function() {
          gwpSkus.push($(this).data('gwp-product-sku'));
          gwpHandles.push($(this).data('gwp-product-handle'));
        });
        props._gwp_sku = gwpSkus.join(',');
        props._gwp_handle = gwpHandles.join('-');
      }

      if (hasTradeIn === true) {
        props._tradeIn_value = parsedTradeInValue;
        props._tradeIn_device = tradeInDevice;
        props._tradeInEligible = 'true';
      }

      var items = [
        {
          id: prodVariantID,
          quantity: prodQuant,
          properties: props
        }
      ];

      if (isChecked == true) {
        items.push({
          id: applecareID,
          quantity: prodQuant,
          properties: {
            _aplcr_main_product_sku: main_product_sku,
            _aplcr_main_product_handle: main_product_handle,
            _uuid: uid
          }
        });
      }

      if (isChecked2 == true) {
        items.push({
          id: secWarrantyID,
          quantity: prodQuant,
          properties: {
            _sw_main_product_sku: main_product_sku,
            _sw_main_product_handle: main_product_handle,
            _uuid: uid
          }
        });
      }

      if (hasGwp) {
        gwpData.each(function() {
          items.push({
            id: $(this).data('gwp-id'),
            quantity: $(this).data('gwp-quantity'),
            properties: {
              _gwp_main_product_sku: main_product_sku,
              _gwp_main_product_handle: main_product_handle,
              _uuid: uid
            }
          });
        });
      }

      const adobeItems = [
        {
          id: secWarrantyID,
          quantity: prodQuant,
        },
        {
          id: applecareID,
          quantity: prodQuant,
        },
        {
          id: prodVariantID,
          quantity: prodQuant,
        }
      ];

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "post",
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({items}),
      })
        .then(response => {
          response.json().then(d => {
            if ($(".pdp_product_list").attr("value").indexOf('PLP ::') >= 0) {
              var proliststring = $(".pdp_product_list").attr("value");
            } else {
              var proliststring = formatString($(".pdp_product_list").attr("value"));
            }
            var productList = proliststring;

            removeGwpData(gwpData);

            if (isChecked == true || isChecked2 == true || hasTradeIn === true) {
              if (isChecked == true && isChecked2 == true) {
                cartCookie(mpn_handle, d.items[2].key, productList);
              } else if (isChecked == false && isChecked2 == true) {
                cartCookie(mpn_handle, d.items[1].key, productList);
              } else if (isChecked == true && isChecked2 == false) {
                cartCookie(mpn_handle, d.items[1].key, productList);
              } else if (hasTradeIn === true) {
                cartCookie(mpn_handle, d.items[0].key, productList);
              }
            } else {
              cartCookie(mpn_handle, d.items[0].key, productList);
            }

            triggerGAAddToCart(productcomPrice, mpn_handle, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prodVariantID);
            if ($cartDrawer) {
              $cartDrawer.updateItems();
            }
            if ($CTOcartDrawer.length && !$CTOcartDrawer.hasClass('hidden')) {
              $CTOcartDrawer[0].updateItems(d.items);
            }

            adobeTrack(adobeItems);
          })
          if (check_buy == "buy") {
            $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
              var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
              if ($('.cart-count-bubble').length > 0) {
                $('.cart-count-bubble span').text(item_count);
              } else {
                $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                $('.cart-count-bubble span').text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                $('#cart-notification').addClass('minicart-active');
              }
              $("#cart-notification").css("visibility", "hidden");
              $(".cart-count-bubble").css("visibility", "hidden");
              window.location.href = `${window.Shopify.routes.root}checkout`;
            });
          } else {
            $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
              var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
              if ($('.cart-count-bubble').length > 0) {
                $('.cart-count-bubble span').text(item_count);
              } else {
                $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
                $('.cart-count-bubble span').text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              if (!$CTOcartDrawer.length || $CTOcartDrawer.hasClass('hidden')) {
                $('#cart-notification').addClass('minicart-active');
              }
            });
            var main_product_sku = $("#main-pro-sku").val();
            var productCategory = $(".pdp_product_category").attr("value");
            var productCurrency = $(".pdp_product_currency").attr("value");
            var productPrice = $("#prod_price_" + prodVariantID).val();
            var productTitle = $(".pdp_product_title").attr("value");
            var prodQuant = $("#prodQuantity").val();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          return false;
        })
        .finally(() => {
          disablePdpButton(false);
        });
    }

    function removeGwpData(gwpData) {
      const metaobjectIds = [];
      gwpData.each(function() {
        metaobjectIds.push($(this).data('gwp-metaobject-id'));
      });

      metaobjectIds.forEach((id) => {
        $(`.js-gwp-data[data-gwp-metaobject-id="${id}"], .js-slider-form-gwp-data[data-gwp-metaobject-id="${id}"]`).remove();
      });
    }

    function cartCookie(mpn_handle, prodVariantID, productList) {
        var prevPage = document.referrer;
        var search_value = '';
        var first_search = '';
        if (prevPage.includes("search")) {
            first_search = localStorage.getItem("search_value");
            search_value = localStorage.getItem("search_value_term");
            if (first_search == null) {
                localStorage.setItem("search_value", search_value);
                var first_search_str = localStorage.getItem("search_value");
                first_search = formatString(first_search_str);
            }
        }
        var exphone = [];
        var item_cart = {}
        item_cart["cart_item_id"] = prodVariantID;
        item_cart["cart_item_list_name"] = productList;
        item_cart["cart_item_mpn"] = mpn_handle;
        item_cart["cart_search_term"] = first_search;
        if (JSON.parse(localStorage.getItem("cart")) != null) {
            exphone = JSON.parse(localStorage.getItem("cart"));
        }
        exphone.push(item_cart);
        localStorage.setItem("cart", JSON.stringify(exphone));
        // console.log(JSON.parse(localStorage.getItem("cart")));
    }

    function triggerGAAddToCart(productcomPrice, mpn, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prod_variantID) {
        var prevPage = document.referrer;
        var search_value = '';
        if (prevPage.includes("search")) {
            var first_search = localStorage.getItem("search_value");
            search_value = localStorage.getItem("search_value_term");
            if (first_search == null) {
                localStorage.setItem("search_value", search_value);
                var first_search_str = localStorage.getItem("search_value");
                first_search = formatString(first_search_str);
            }
        }
        dataLayer.push({
            'ecommerce': null
        });
        productPrice = Number(productPrice?.replace(/[^0-9.-]+/g, ""));
        var value_price = productPrice * parseInt(prodQuant);
        var discount = 0;
        var value_price1 = parseFloat(value_price);
        var productPrice1 = parseFloat(productPrice);
        dataLayer.push({
            'event': 'add_to_cart',
            'search_term': search_value,
            'currency': productCurrency,
            'value': value_price1,
            'ecommerce': {
                'items': [{
                    'item_id': mpn,
                    'item_name': productTitle,
                    'item_category': productCategory,
                    'item_list_name': productList,
                    'price': productPrice1,
                    'quantity': parseInt(prodQuant)
                }]
            }
        });
    }


    function formatString(str) {
      if (!str) return '';
        return str
            .replace(/(\B)[^ ]*/g, match => (match.toLowerCase()))
            .replace(/^[^ ]/g, match => (match.toUpperCase()));
    }

    /* Minicart starts here - added by Hema*/
    function miniCart() {
        $.get(`${window.Shopify.routes.root}cart?view=minicart`, function(itemData) {
            $('cart-notification').replaceWith(itemData);
            $('#cart-notification').addClass('minicart-active');
            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: `${window.Shopify.routes.root}cart.js`,
                success: function(cart) {
                    let total = cart.item_count;
                    $('.cart-count-bubble').text(total);
                }
            });

        });
    }

    if ($productGrid) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation?.type === 'childList') {
            // reinit quick add buttons
            quickAddEvents();
          }
        });
      });
      observer.observe($productGrid, { childList: true });
    }

    $("#prodQuantity").on("change", function() {
      debounce(checkQty, 500)();
    });

    function checkQty() {
      var productId = $("#product_id").val();
      var productQty = $("#prodQuantity").val();
      var prodMaxQty = $("#product_max_quantity").val();
      var prodInventoryQuantity = $("#productInventoryQuantity").val();
      var $errorMessage = document.querySelector('.js-qty-error') || null;
      var $qtyInput = document.querySelector('.js-qty-input') || null;
      var $pickUpAvailability = document.querySelectorAll('pickup-availability') || null;
      var $storeLocator = document.querySelector('my-store-locator') || null;

      if ($storeLocator && $pickUpAvailability?.length > 0 && productQty) {

        [...$pickUpAvailability].forEach((el) => {
          var locationId = $storeLocator.preferredStoreId || null;
          el.dataset.itemQuantity = productQty ? parseInt(productQty) : null;

          if (locationId) {
            var location = $storeLocator?.allLocationsData?.find((loc) => loc.id === locationId) || null;
            if (location) {
              el.renderPreview(location);
            }
          }
        });
      }

      var maxQty = checkMaxquantity(productId);

      if (maxQty != "") {
          var maxQtyAllowed = parseInt(productQty) + parseInt(maxQty);
      } else {
          var maxQtyAllowed = parseInt(productQty);
      }

      if (maxQtyAllowed > prodMaxQty) {
        if ($errorMessage) {
          const text = $errorMessage.innerHTML;

          if (text) {
            if (text.includes('{limit}')) {
              $errorMessage.innerHTML = text.replace('{limit}',`(${prodMaxQty})`);
              $errorMessage.classList.remove('hidden');
            } else {
              $errorMessage.classList.remove('hidden');
            }
          }
        }
        if ($qtyInput) {
          $qtyInput.classList.add('quantity--error');
        }
        return false;
      } else if (maxQtyAllowed > parseInt(prodInventoryQuantity)) {
        if ($errorMessage) {
          const maxLevel = parseInt(prodInventoryQuantity);
          const text = $errorMessage.innerHTML;

          if (text) {
            if (text.includes('{limit}')) {
              $errorMessage.innerHTML = text.replace('{limit}', `(${maxLevel})`);
              $errorMessage.classList.remove('hidden');
            } else {
              $errorMessage.classList.remove('hidden');
            }
          }
        }

        if ($qtyInput) {
          $qtyInput.classList.add('quantity--error');
        }
        return false;
      } else {
        resetErrors();
        return true;
      }
    }

    function resetErrors() {
      var $errorMessage = document?.querySelector('.js-qty-error') || null;
      var $qtyInput = document?.querySelector('.js-qty-input') || null;

      if ($errorMessage) {
        $errorMessage.classList.add('hidden');
      }
      if ($qtyInput) {
        $qtyInput.classList.remove('quantity--error');
      }
    }
});
/* Minicart ends here - added by Hema*/


function checkMaxquantity(product_id) {
    var total_max_quantity = 0;
    var product_id = product_id;
    $.ajax({
        type: 'GET',
        dataType: 'json',
        async: false,
        url: `${window.Shopify.routes.root}cart.js`,
        success: function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
                var product_cartid = cart.items[i].product_id;
                if (product_cartid == product_id) {
                    total_max_quantity += cart.items[i].quantity;
                }
            }
        }
    });
    return total_max_quantity;
}

function checkQuantity() {
    var total_quantity = 0;
    var cart_key = [];
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: `${window.Shopify.routes.root}cart.js`,
        success: function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
                var tags = cart.items[i].properties.__taxtags;
                if (tags != undefined) {
                    var list = tags.split(',');
                    var found = false;
                    for (var j = 0; j < list.length; ++j) {
                        cart_key.push(cart.items[i].properties.__taxtags);
                        if (list[j] == 'taxfree') {
                            total_quantity += cart.items[i].quantity;
                        }
                    }
                }
            }
            setCookie('total_quantity', total_quantity, 7);
            setCookie('cart_key', cart_key, 7);
        }
    });
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
